/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { CHANGE_USERNAME, ON_CALL_UPLOAD, FAILED_ANX1_VAL, RESET_FETCH_FAILED, ON_NOTIFY, LOADER_STATUS, TOTAL_RECORD, ANX1_GET_ITEM, ANX1_TOTAL_ITEM_RECORDS, TXN_RECORD, RESET_ANX1_VAL } from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  uploadData: '',
  failedAnx1Data: [],
  status: false,
  msg: '',
  loaderStatus: false,
  anx1TotalItemRecord: '',
  anx1ItemData: '',
  totalItemRecord: '',
  propsTxnId: '',
  totalRecords: ''
};

/* eslint-disable default-case, no-param-reassign */
const failedAnx1Reducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
      case FAILED_ANX1_VAL:
        return {
          ...state,
          failedAnx1Data:action.failedAnx1Data
        }
      case ON_NOTIFY:
        return {
          ...state,
          status:action.status,
          msg:action.msg
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case TOTAL_RECORD:
        return {
          ...state,
          totalRecords:action.totalRecords
        }
      case TXN_RECORD: 
        return {
          ...state,
          propsTxnId:action.propsTxnId
        }
      case ANX1_GET_ITEM:
        return {
          ...state,
          anx1ItemData:action.anx1ItemData
        }
      case ANX1_TOTAL_ITEM_RECORDS:
        return {
          ...state,
          anx1TotalItemRecord:action.anx1TotalItemRecord
        }
      case RESET_ANX1_VAL:
        return {
          ...state,
          failedAnx1Data:action.failedAnx1Data
        }
      default:
        return state;
    }
  };

export default failedAnx1Reducer;
